export const MaritalStatus = [
  {
    _id: 0,
    title: "Married",
  },
  {
    _id: 1,
    title: "Single",
  },
  {
    _id: 2,
    title: "Single Mother",
  },
  {
    _id: 3,
    title: "Single Father",
  },
  {
    _id: 4,
    title: "Divorced",
  },
];
